import React from 'react';
import { useIntl } from 'react-intl';

import Link from '@/components/switchback/Link/Link';
import { IAdjacentPost } from '@/services/types/blog/post.types';

interface IBottomNav {
  next: IAdjacentPost;
  previous: IAdjacentPost;
}

const TopNav: React.FC<IBottomNav> = ({ next, previous }) => {
  const intl = useIntl();
  const previouPost = intl.formatMessage({ defaultMessage: 'Previous Post', id: '7HxQY7' });
  const nextPost = intl.formatMessage({ defaultMessage: 'Next Post', id: 'bCQqv5' });

  const nextLinkHref = '/blog/[blogPostSlug]';
  const prevHref = `/blog/${previous.slug}`;
  const nextHref = `/blog/${next.slug}`;

  return (
    <div className="m-auto grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-8 highlight autoType600 leading-7">
      {!!(previous.slug && previous.title) && (
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
          <div>{previouPost}</div>
          <Link legacy href={nextLinkHref} as={prevHref}>
            <a href={prevHref} rel="prev" dangerouslySetInnerHTML={{ __html: previous.title }} />
          </Link>
        </div>
      )}
      {!!(next.slug && next.title) && (
        <div className="flex flex-col items-center text-center lg:items-end lg:text-right">
          <div>{nextPost}</div>
          <Link legacy href={nextLinkHref} as={nextHref}>
            <a href={nextHref} rel="next" dangerouslySetInnerHTML={{ __html: next.title }} />
          </Link>
        </div>
      )}
    </div>
  );
};

export default TopNav;
